import { Container, Graphics } from 'pixi.js';

/**
 * Soft cloud wisps for the stage backdrop (Ancient Egypt theme).
 * Coordinates match the large world backdrop (centered at origin).
 */
export function createOlympusBackdrop(theme) {
  const root = new Container();
  root.eventMode = 'none';

  const layer = new Graphics();
  const cx = 0;
  const cy = 0;

  const clouds = [
    { x: -900, y: -700, rx: 520, ry: 180, a: 0.12 },
    { x: 200, y: -820, rx: 640, ry: 220, a: 0.1 },
    { x: 850, y: -500, rx: 480, ry: 160, a: 0.11 },
    { x: -400, y: 200, rx: 700, ry: 200, a: 0.07 },
    { x: 500, y: 350, rx: 560, ry: 190, a: 0.08 },
    { x: -1100, y: 400, rx: 450, ry: 150, a: 0.06 },
  ];

  for (const c of clouds) {
    layer.ellipse(cx + c.x, cy + c.y, c.rx, c.ry).fill({ color: theme.cloudTint, alpha: c.a });
  }

  layer.ellipse(cx, cy + 450, 1400, 500).fill({ color: theme.cloudTint, alpha: 0.04 });

  layer.eventMode = 'none';
  root.addChild(layer);
  return root;
}
